import { AgGridColumnDef } from '@tassat/common-definitions';
import { AccountWithdrawalDataRecord } from '@tassat/fred-definitions';

import WithdrawalInstructionCellRenderer from 'SharedComponents/cellRenderComponent/withdrawalInstructionCellRenderer';

export const cellHeight = 74;

const didWithdrawalInstructionsUpdate =
(withdrawalInstructionsA: AccountWithdrawalDataRecord, withdrawalInstructionsB: AccountWithdrawalDataRecord) => {
    if (!withdrawalInstructionsA) {
        return !withdrawalInstructionsB;
    } else {
        return withdrawalInstructionsA.AccountWithdrawalDataId === withdrawalInstructionsB.AccountWithdrawalDataId &&
            withdrawalInstructionsA.FirmId === withdrawalInstructionsB.FirmId &&
            withdrawalInstructionsA.Description === withdrawalInstructionsB.Description &&
            withdrawalInstructionsA.IsDefault === withdrawalInstructionsB.IsDefault;
    }
};

export const firmWithdrawalColumnDefs: AgGridColumnDef[] = [
    {
        field: '',
        headerName: '',
        cellRenderer: WithdrawalInstructionCellRenderer,
        cellRendererParams: { cellHeight: cellHeight },
        valueGetter: ({ data }) => data,
        equals: didWithdrawalInstructionsUpdate,
        menuTabs: [],
        flex: 1
    },
    {
        field: 'Description',
        hide: true,
        sort: 'asc'
    }
];